export const genesisNFTVestingStakingContract = {
  abi: [
    {
      inputs: [
        {
          internalType: 'address',
          name: '_owner',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_wlth',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: '_allocation',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_distributionStartTimestamp',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: '_leftoversUnlockDelay',
          type: 'uint256',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'constructor',
    },
    {
      inputs: [],
      name: 'StakingGenesisNFTVesting__AddressFromZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'StakingGenesisNFTVesting__AddressToZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'StakingGenesisNFTVesting__DistributionNotStarted',
      type: 'error',
    },
    {
      inputs: [],
      name: 'StakingGenesisNFTVesting__DistributionStartTimestampAlreadySet',
      type: 'error',
    },
    {
      inputs: [],
      name: 'StakingGenesisNFTVesting__LeftoversWithdrawalLocked',
      type: 'error',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'StakingGenesisNFTVesting__NoRewardsForUser',
      type: 'error',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: 'balance',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: 'released',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: 'allocation',
          type: 'uint256',
        },
      ],
      name: 'StakingGenesisNFTVesting__NoSurplus',
      type: 'error',
    },
    {
      inputs: [],
      name: 'StakingGenesisNFTVesting__NotEnoughTokens',
      type: 'error',
    },
    {
      inputs: [],
      name: 'StakingGenesisNFTVesting__OwnerZeroAddress',
      type: 'error',
    },
    {
      inputs: [],
      name: 'StakingGenesisNFTVesting__PastDistributionStartTimestamp',
      type: 'error',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: 'allocation',
          type: 'uint256',
        },
        {
          internalType: 'uint256',
          name: 'totalRewards',
          type: 'uint256',
        },
      ],
      name: 'StakingGenesisNFTVesting__RewardsTooHigh',
      type: 'error',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'StakingGenesisNFTVesting__WalletAlreadyLost',
      type: 'error',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'StakingGenesisNFTVesting__WalletLost',
      type: 'error',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'StakingGenesisNFTVesting__WalletNotLost',
      type: 'error',
    },
    {
      inputs: [],
      name: 'StakingGenesisNFTVesting__WlthZeroAddress',
      type: 'error',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: 'uint256',
          name: 'timestamp',
          type: 'uint256',
        },
      ],
      name: 'DistributionStartTimestampSet',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'from',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
      ],
      name: 'EmergencyWithdrawalPerformed',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'LeftoversWithdrawn',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'LostWalletReseted',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'wallet',
          type: 'address',
        },
      ],
      name: 'LostWalletSet',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'previousOwner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'OwnershipTransferred',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'beneficiary',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'Released',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          components: [
            {
              internalType: 'address',
              name: 'account',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'series1Rewards',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'series2Rewards',
              type: 'uint256',
            },
          ],
          indexed: false,
          internalType: 'struct IStakingGenesisNFTVesting.Rewards[]',
          name: 'rewards',
          type: 'tuple[]',
        },
      ],
      name: 'RewardsSet',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'SurplusWithdrawn',
      type: 'event',
    },
    {
      inputs: [],
      name: 'allocation',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'distributionStartTimestamp',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_from',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_to',
          type: 'address',
        },
      ],
      name: 'emergencyWithdraw',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'leftoversUnlockDelay',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_wallet',
          type: 'address',
        },
      ],
      name: 'lostWallet',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'owner',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'release',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_account',
          type: 'address',
        },
      ],
      name: 'releaseableAmount',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'releasedAmount',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'renounceOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_wallet',
          type: 'address',
        },
      ],
      name: 'resetLostWallet',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_account',
          type: 'address',
        },
      ],
      name: 'series1Rewards',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_account',
          type: 'address',
        },
      ],
      name: 'series2Rewards',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'uint256',
          name: '_timestamp',
          type: 'uint256',
        },
      ],
      name: 'setDistributionStartTimestamp',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_wallet',
          type: 'address',
        },
      ],
      name: 'setLostWallet',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          components: [
            {
              internalType: 'address',
              name: 'account',
              type: 'address',
            },
            {
              internalType: 'uint256',
              name: 'series1Rewards',
              type: 'uint256',
            },
            {
              internalType: 'uint256',
              name: 'series2Rewards',
              type: 'uint256',
            },
          ],
          internalType: 'struct IStakingGenesisNFTVesting.Rewards[]',
          name: '_rewards',
          type: 'tuple[]',
        },
      ],
      name: 'setRewards',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'totalRewards',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'newOwner',
          type: 'address',
        },
      ],
      name: 'transferOwnership',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_account',
          type: 'address',
        },
      ],
      name: 'userClaimed',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_account',
          type: 'address',
        },
      ],
      name: 'withdrawLeftovers',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: '_wallet',
          type: 'address',
        },
      ],
      name: 'withdrawSurplus',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'wlth',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
  ],
}
